import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';
import { designTokens } from '../tokens';

export type LoadingIndicatorProps =
  | { label: string; labelledBy?: never }
  | { label?: never; labelledBy: string };

const pulse = keyframes({
  '0%, 80%, 100%': { transform: 'scale(0)' },
  '40%': { transform: 'scale(1)' },
  '0%, 79%, 100%': { opacity: 0.6 },
  '27%': { opacity: 1 },
  '53%': { opacity: 0.8 },
});

/** 화면·영역 조회를 기다리는 표시입니다. 조회 수명과 완료 후 내용은 호출자가 소유합니다. */
export function LoadingIndicator({ label, labelledBy }: LoadingIndicatorProps) {
  const dots = designTokens.loading.dots;
  return <Box
    role="progressbar"
    aria-label={label}
    aria-labelledby={labelledBy}
    sx={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0, gap: `${dots.gap}px`, minHeight: dots.size, color: 'text.secondary' }}
  >
    {[0, 1, 2].map((index) => <Box key={index} aria-hidden="true" sx={{
      width: dots.size,
      height: dots.size,
      borderRadius: designTokens.radius.circle,
      bgcolor: 'currentColor',
      animation: `${pulse} ${dots.duration}ms ease-in-out ${index * dots.delay}ms infinite both`,
      '@media (prefers-reduced-motion: reduce)': { animation: 'none !important', transform: 'none', opacity: 0.7 },
      '@media (forced-colors: active)': { backgroundColor: 'CanvasText' },
    }} />)}
  </Box>;
}
